import { useState } from 'react';
import { TextField, Button, Grid, Typography, Paper } from '@mui/material';
import { apiActivation } from '../../services/activation/Activation';
import { useParams } from 'react-router-dom';

const ActivationComponent = () => {
    const { guid } = useParams();
    const [password, setPassword] = useState('');
    const [validationMessage, setValidationMessage] = useState('');
    const [isLoading, setIsLoading] = useState(false);

    const handlePasswordChange = (e) => {
        setPassword(e.target.value);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        // Here you can add your login logic, like sending a request to the server

        if (!isLoading) {
            setIsLoading(true);
            let result = await apiActivation.post({
                password: password,
                activationLink: guid,
            });

            if (result.error) {
                setIsLoading(false);
                setValidationMessage(result.error);
            }

            setIsLoading(false);
            setValidationMessage(
                'Hasło zostało zresetowane. Możesz się teraz zalogować do aplikacji.',
            );
        }

        // Reset the form after submission
        setPassword('');
    };

    return (
        <div className="home-container">
            <br />
            <br />
            <div className="home-hero">
                <Grid
                    container
                    justifyContent="center"
                    className="padding-body-2"
                >
                    <Grid item xs={12} sm={6} md={4}>
                        <Paper elevation={3} variant="outlined" square>
                            <form onSubmit={handleSubmit}>
                                <Typography variant="h5" gutterBottom>
                                    Nowe hasło
                                </Typography>
                                <Grid item xs={12}>
                                    {validationMessage && (
                                        <div className="validation-error-green">
                                            Hasło zostało zmienione. Możesz się
                                            teraz zalogować na nowe hasło.
                                        </div>
                                    )}
                                </Grid>
                                <TextField
                                    type="password"
                                    label="Hasło"
                                    variant="outlined"
                                    fullWidth
                                    margin="normal"
                                    value={password}
                                    onChange={handlePasswordChange}
                                    required
                                    autoComplete="off"
                                />

                                <Button
                                    type="submit"
                                    variant="contained"
                                    fullWidth
                                    size="large"
                                    className="buttonFilled"
                                >
                                    {isLoading && (
                                        <span className="loader"></span>
                                    )}
                                    {!isLoading && <span>Zresetuj</span>}
                                </Button>
                            </form>
                        </Paper>
                    </Grid>
                </Grid>
            </div>
        </div>
    );
};

export default ActivationComponent;
